import React from 'react';
import classNames from 'classnames';
import styles from './HeroBanner.module.scss';
import Button from '../Button';

const DEFAULT_ALT_IMAGE = 'Hero Banner Image';

export type TextType = {
  text: string;
  color?: string;
};

export type ButtonType = {
  label: string;
  onClick: () => void;
  included: boolean;
};

export type HeroBannerProps = {
  headline: TextType;
  caption: TextType;
  disclaimer?: TextType;
  primaryCTA?: ButtonType;
  secondaryCTA?: ButtonType;
  backgroundImage: string;
  customClassName?: string;
};

const HeroBanner: React.FC<HeroBannerProps> = ({
  headline,
  caption,
  primaryCTA,
  secondaryCTA,
  backgroundImage,
  customClassName,
  disclaimer,
}) => {
  const textWrapper = classNames(styles.textWrapper, customClassName);
  const showSecondaryCTA = secondaryCTA?.included;

  return (
    <div className={styles.container}>
      <img className={styles.image} alt={DEFAULT_ALT_IMAGE} src={backgroundImage} />
      <div className={textWrapper}>
        <h1 style={{ color: headline.color }} className={styles.title}>
          {headline.text}
        </h1>
        <h2 style={{ color: caption.color }} className={styles.description}>
          {caption.text}
        </h2>
        {disclaimer && (
          <p style={{ color: disclaimer.color }} className={styles.disclaimer}>
            {disclaimer.text}
          </p>
        )}
        <div className={styles.buttonsWrapper}>
          <Button onClick={primaryCTA?.onClick}>{primaryCTA?.label}</Button>
          {showSecondaryCTA && <Button onClick={secondaryCTA.onClick}>{secondaryCTA.label}</Button>}
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
